export default __webpack_public_path__ + "static/erubnnEB-2f835649385c985e89508354dde14f92.svg";